import { useQuery } from "@tanstack/react-query"
import { backofficeCampaignsQuery } from "modules/backoffice/lib/campaigns/backofficeCampaignsQuery"

export function useBackofficeCampaignsQuery(...args: Parameters<typeof backofficeCampaignsQuery>) {
  return useQuery(backofficeCampaignsQuery(...args))
}
